import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../../core/services/helpers.service';
import { ModalNotifyService } from '../../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../../core/services/operations.service';
import { ClassificazionePraticaFormComponent } from '../../../../form/classificazione-pratica-form.component';
import { Classificazione } from '../../../../models/classificazione';
import { ClassificazioneResponse } from '../../../../models/dto/classificazione-response';
import { ClassificazioneSezione } from '../../../../models/sezioni/classificazione-sezione';

@Component({
    selector: 'div [classificazione-pratica-add]',
  templateUrl: '../../../../form/classificazione-pratica-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ClassificazionePraticaAddComponent extends ClassificazionePraticaFormComponent implements OnInit {
  idSezione: string;
  idPratica: string;
  urlCreateClassificazione: string;

  @Output()
  onReturn: EventEmitter<ClassificazioneSezione> = new EventEmitter<ClassificazioneSezione>();

  constructor(@Inject(HelpersService) helpersService: HelpersService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(ModalNotifyService) mns: ModalNotifyService, private operationService: OperationsService) {
      super(helpersService, campiForm, mns);
  }

  ngOnInit() {
    this.setTitle('Classificazione');
    this.isInserimento(true);
  }

  getRequest(request: Classificazione, manageCall: {executeCall: boolean, closeModal: boolean}) {
    if (manageCall.executeCall) {
      this.operationService.createClassificazione(this.urlCreateClassificazione, this.idSezione, this.idPratica, request)
        .subscribe(response => this.classificazioneCreated(response));
    } else if (manageCall.closeModal) {
      this.onReturn.emit(null);
    }
  }

  classificazioneCreated(response: ClassificazioneResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  getClassificazione() {
    return null;
  }

  inizializza(idSezione: string, urlCreateClassificazione: string, idPratica: string, listaClassificazioni: Classificazione[]) {
    this.idSezione = idSezione;
    this.urlCreateClassificazione = urlCreateClassificazione;
    this.idPratica = idPratica;
    this.setIdTipoPratica(idPratica);
    this.inizializzaForm(listaClassificazioni);
  }

  canCheckPrimary(): boolean {
    return true;
  }
}
